// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".faq-container[data-v-850b0bea]{border-top:1px solid #e8e8e8}.q-and-a[data-v-850b0bea]{border-bottom:1px solid #e8e8e8}", ""]);
// Exports
module.exports = exports;
